<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'dialogs.cashRegister.openTitle' | translate }}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <u2b-message type="info">
            <span [innerHTML]="'dialogs.cashRegister.openCashInfoHtml' | translate : { title: cashRegister?.title }"></span>
        </u2b-message>

        <ng-container *ngIf="previousDayCashError">
            <u2b-message type="error">
                {{ 'dialogs.cashRegister.openPreviousDayLoadError' | translate }}
            </u2b-message>
        </ng-container>

        <ng-container *ngIf="formGroup">
            <form [formGroup]="formGroup" class="mt-24">

                <div class="mb-24" fxLayout="column" fxLayoutAlign="start start">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>{{ 'dialogs.cashRegister.openBalanceLabel' | translate }}</mat-label>
                        <input type="number" matInput data-test="FI-Kassenbestand bei Eröffnung" formControlName="cash">
                        <mat-hint>{{ 'dialogs.cashRegister.openPreviousDayHint' | translate }}
                            {{ previousDayCash ? (previousDayCash | bcmDynamicCurrency) : ('dialogs.cashRegister.noPreviousDayData' | translate) }}</mat-hint>
                        <mat-error>{{formGroup.get('cash').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>
                </div>

            </form>
        </ng-container>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <button data-test="B-Abbrechen" mat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>
        <button data-test="B-Kasse eröffnen" mat-flat-button
                color="accent"
                (click)="openCashRegister()"
                class="save-button mat-accent"
                [disabled]="!formGroup.valid || isLoading"
                [attr.aria-label]="'dialogs.cashRegister.openButtonAria' | translate">
            <mat-icon>point_of_sale</mat-icon>
            <span>{{ 'dialogs.cashRegister.openButton' | translate }}</span>
            <ng-container *ngIf="isLoading">
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-container>
        </button>
    </div>

</div>
